import {SET_KEY} from './actionTypes';

export const setKey = (noAuthKey) => {
  return {
    type: SET_KEY,
    payload: {noAuthKey: noAuthKey}
  }
}



/** WEBPACK FOOTER **
 ** ./src/_shared/actions/setKey.js
 **/